import { render, staticRenderFns } from "./DomainMonitorButton.vue?vue&type=template&id=0fed1664&"
import script from "./DomainMonitorButton.vue?vue&type=script&lang=js&"
export * from "./DomainMonitorButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports